import React, { useContext, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../AuthContext'; // Пример подключения контекста авторизации
import s from '../styles/Menu.module.css';
import { useNavigate } from 'react-router-dom';
import Avatar from './Avatar'; // путь к файлу компонента




function SettingsPage() {
  

  const {currentUser } = useContext(AuthContext); // Получаем текущее состояние пользователя
  const [profile, setProfile] = useState(null);  // Состояние для хранения данных профиля
  const navigate = useNavigate();



  // Функция получения профиля текущего пользователя
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        // Проверяем, есть ли данные initData в localStorage (для пользователей из Telegram)
        const token = localStorage.getItem("jwtToken"); 
        console.log('токен:',token)
        let options = {
          method: 'GET',  // Метод указывается всегда
        };

        // Если есть initData (пользователь из Telegram), добавляем его в заголовки
        if (token) {
          options.headers = {
            "Content-Type": "application/json",
            "Authorization": token,  // Передаем JWT в заголовке
          };
        } else {
          // Если пользователь не из Telegram, включаем поддержку сессий через куки
          options.credentials = 'include';
        }

        const response = await fetch('/api/profile', options);



        if (response.ok) {
          const data = await response.json();
          setProfile(data);
        } else {
          if (response.status === 404) {
            navigate('/');  // Перенаправляем, если профиль не найден
          } else {
            console.error('Error fetching profile');
            
            
          }
        }
      } catch (error) {
        console.error('Error:', error);
      
      } 
      // finally {
      //   setLoading(false);  // Завершаем загрузку
      // }
    };

    fetchProfile();
  }, [navigate]);







  return (
    <div className={s.prof_div}>
    <h1 className='all_str_h1'>Мой профиль</h1>
    <div className={s.back2}>                
      </div>
    
    <div className={s.profile_container}>
     
      <div className={s.back}>
          <Link to="/dashboard" className={s.btn_prev_2}>
            X
          </Link>                 
      </div>
      <div className={s.profile}>
              <Avatar userId={currentUser.id} />  
            </div>

      <div className={s.profile_div}>
            {currentUser && profile ? (
              <>
                <div className={s.name_age_2}>
                  <p>{profile.name}</p>
                </div>
              </>
            ) : (
              <p>Загрузка...</p> // Или другое сообщение, пока профиль загружается
            )}
          </div>     

      <div className={s.settings_options_div}>
      <section className={s.settings_menu}>
        <ul>
          {currentUser ? (
            <>
              <li>
              <Link to="/logout">Выйти</Link>
              </li>
            </>
          ) : (
            <>
              {/* Отображаем меню для неавторизованного пользователя */}
             
              <li>
                <Link to="/login">Login</Link>
              </li>
             
              
            </>
          )}
          
        </ul>
        </section>
        </div>
    </div>
    
    
      
  </div>
  );
}

export default SettingsPage;





